module.exports = __webpack_public_path__ + "static/media/pg_testing_a_bg.14ee3e55.jpg";